import { render, staticRenderFns } from "./BlockListNewsListCustom.vue?vue&type=template&id=b1240f10&"
import script from "./BlockListNewsListCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListNewsListCustom.vue?vue&type=script&lang=js&"
import style0 from "./BlockListNewsListCustom.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports